import { LoadingSpinner } from '@aibees/elephant/components/loading-spinner';
import { UnlockProfileDetails } from '@aibees/elephant/components/unlock-profile-details';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { useContactDetailsData } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/context';
import { useContactDetailsEnrichmentDescriptionText } from '@aibees/elephant/hooks/people/use-contact-details-enrichment-description-text';
import { Grid2, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { ProfileDetailsCard } from './profile-details-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfileDetailsPopoverProps as Props } from './types';

export const ProfileDetailsPopover = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();
  const { unlockableItems } = useContactDetailsData();
  const descriptionText = useContactDetailsEnrichmentDescriptionText(api.data);

  if (!api?.data) {
    return (
      <Styled.Wrapper
        className={classnames('ProfileDetailsPopover', className)}
        sx={SX.root(true)}
      >
        <LoadingSpinner
          textIncluded
          textColor="grey.700"
          circularProgressColor="inherit"
        />
      </Styled.Wrapper>
    );
  }

  return (
    <Styled.Wrapper
      className={classnames('ProfileDetailsPopover', className)}
      sx={SX.root(false)}
    >
      <Stack p={1} pb={0}>
        <Box display="flex" alignItems="center" gap={1}>
          <Icon name="badge-outline" size={20} color={'primary.500'} />

          <Typography variant="body3" fontWeight={700} color="grey.700">
            Profile Insights
          </Typography>
        </Box>
      </Stack>
      <Divider />

      <Stack sx={SX.profileDetailsContent}>
        {!!unlockableItems.length && (
          <Grid2
            justifyContent="space-between"
            alignItems="center"
            paddingX={1}
          >
            <Typography variant="body3" color="grey.500" fontWeight={400}>
              {descriptionText}
            </Typography>

            <UnlockProfileDetails />
          </Grid2>
        )}
        <ProfileDetailsCard />
      </Stack>
    </Styled.Wrapper>
  );
});

ProfileDetailsPopover.displayName = 'ProfileDetailsPopover';
